<script>
export default {
  name: 'EaChooser',
  emits: ['update:modelValue'],
  props: {
    options: { type: Object },
    modelValue: { type: [String, Boolean] },
    value: { type: String, default: 'value' },
    colorized: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    disabledValues: { type: Array, default: () => [] },
    name: { type: String, required: true },
    label: { type: String, default: '' },
    validators: { type: Object, default: null },
    stretch: { type: Boolean, default: false },
    slim: { type: Boolean, default: false },
    nowrap: { type: Boolean, default: true },
    additionalErrors: {
      type: Array,
      default: () => [],
      validator(val) {
        return !val.find(item => item.constructor != String)
      },
    },
  },
  methods: {
    itemClass(option) {
      const { value, activeClass } = option
      return {
        active: this.modelValue === value,
        [activeClass]: this.modelValue === value,
        slim: this.slim,
        'text-nowrap': this.nowrap,
        'w-100': this.stretch,
      }
    },
  },
}
</script>

<template lang="pug">
form-control-container(
  :additional-errors="additionalErrors"
  :label="label"
  :name="name"
  :validators="validators"
  :value="modelValue"
  hideInvalidIcon
)
  .options-container.d-flex.justify-content-center
    .ea-chooser_option-container(
      v-for="option in options"
      :class="{ 'flex-grow-1': stretch }"
      :key="option.value"
      v-tooltip="option.tooltip"
    )
      button.btn.ea-chooser_option-button(
        :class="itemClass(option)"
        :disabled="disabled || (disabledValues || []).includes(option.value)"
        :id="option.value"
        :name="name"
        @click="$emit('update:modelValue', option.value)"
        type="button"
      )
        i.mi-outlined.mi-check.me-1(v-if="option.value === modelValue")
        | {{ option.label }}
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.ea-chooser_option-container {
  display: flex;
}

.ea-chooser_option-button {
  text-align: center;
  padding: 5px 12px;
  cursor: pointer;
  user-select: none;
  border-radius: 100px;
  font-size: inherit;
  font-size: 12px;

  &.active {
    background: map.get(themeVariables.$colors, secondaryContainer);
  }
}
</style>
